import { Control } from "ol/control.js";
import Draw from "ol/interaction/Draw.js";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style.js";
import { Vector as VectorSource } from "ol/source.js";
import { Vector as VectorLayer } from "ol/layer.js";

class Goma extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement("button");
    const tipLabel =
      options.tipLabel !== undefined ? options.tipLabel : "Borrar dibujos";
    button.title = tipLabel;
    button.innerText = "🗑️";

    const element = document.createElement("div");
    element.className = "goma-control ol-unselectable ol-control";
    element.appendChild(button);

    super({ element: element, target: options.target });

    this.draw = null;
    this.measureTooltipElement = null;
    this.helpTooltipElement = null;
    this.active = false;

    button.addEventListener("click", this.clearDrawings.bind(this), false);
  }

  clearDrawings() {
    const map = this.getMap();
    if (!map) return;

    // Get all layers and find the vector ones
    map.getLayers().forEach((layer) => {
      const source = layer.getSource && layer.getSource();
      if (source && source instanceof VectorSource) {
        source.clear(); // Clear all features from that source
      }
    });
  }
}

export default Goma;
